import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";
import { injectIntl } from "@edx/frontend-platform/i18n";

import Unit from "./Unit";
import { ReactComponent as ArrowIcon } from "./svg/arrowIcon.svg";
import { fetchSequenceForSideBar } from "../../data";
import UnitSkelton from "./UnitSkelton";

function SubNav({
  subsectionsId,
  courseId,
  activeSection,
  setActiveSection,
  intl,
}) {
  const [isSubnavOpen, setIsSubnavOpen] = useState(false);
  const dispatch = useDispatch();

  const subSections = useSelector((state) => state.models.sequences);
  const selectedSequenceStatus = useSelector(
    (state) => state.courseware.selectedSequenceStatus
  );
  const selectedSequenceId = useSelector(
    (state) => state.courseware.selectedSequenceId
  );
  const sequenceStatus = useSelector(
    (state) => state.courseware.sequenceStatus
  );
  const sequenceId = useSelector((state) => state.courseware.sequenceId);

  const { title, complete, unitIds = [] } = subSections[subsectionsId] || {};
  const { unitIds: selectedSequenceUnitIds = [] } =
    (activeSection && subSections[activeSection]) || {};

  const isLoading =
    !selectedSequenceUnitIds.length &&
    ((selectedSequenceStatus === "loading" &&
      selectedSequenceId === subsectionsId) ||
      (sequenceStatus === "loading" && sequenceId === subsectionsId));

  const showSubnav = (e, subsectionsId) => {
    e.preventDefault();
    if (isSubnavOpen) {
      setIsSubnavOpen(false);
    } else {
      setActiveSection(subsectionsId);
      setIsSubnavOpen(true);

      const { unitIds: selectedSequenceUnitIds = [] } =
        (subsectionsId && subSections[subsectionsId]) || {};
      const shouldFetchSequenceData =
        !selectedSequenceUnitIds.length && subsectionsId !== sequenceId;

      if (shouldFetchSequenceData) {
        dispatch(fetchSequenceForSideBar(subsectionsId));
      }
    }
  };

  useEffect(() => {
    setIsSubnavOpen(activeSection === subsectionsId);
  }, [activeSection]);

  return (
    <div className="nav-link-wrapper">
      <a
        href="#"
        role="button"
        aria-expanded={isSubnavOpen ? "true" : "false"}
        className={classNames("nav-link", { active: isSubnavOpen })}
        onClick={(e) => showSubnav(e, subsectionsId)}
      >
        <div className="nav-title-wrap">
          <span className="nav-title">{title}</span>
        </div>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </a>
      {isLoading && isSubnavOpen
        ? [1, 2, 3].map((val) => <UnitSkelton key={`skelton-${val}`} />)
        : isSubnavOpen &&
          unitIds.map((unitId) => (
            <Unit
              unitId={unitId}
              courseId={courseId}
              sequenceId={subsectionsId}
            />
          ))}
    </div>
  );
}

export default injectIntl(SubNav);
